import { BootstrapSizes, Button, ButtonColors, Grid } from "@talentech/components";

const Header = () => {
  return (
    <header className="border-bottom border-4 border-branding-2-400">
      <Grid container fluid>
        <Grid item xs={12} className="d-flex justify-content-between align-items-center py-3">
          
          <div>
            <a href="/">
            <img src={"https://storybook.talentech.io/images/svg/LogoTalentech.svg"} alt="logo" />
            </a>
          </div>
          <Button variant="primary" label="Get Started" size={BootstrapSizes.XLARGE}
          color={ButtonColors.PRIMARY}
          onClick={() => {
            document.getElementById("rollout-form")?.scrollIntoView({ behavior: "smooth" });
          }}
          />
        </Grid>
      </Grid>

    </header>
  );
};

export default Header;